import { useMutation } from '@tanstack/react-query';
import apiClient from '../libs/apiClient';
import { ApiResponse } from '../types/response';
import { Session, SessionParams } from '../types/session';

const createSession = async (params: SessionParams) => {
  const { data: responseData } = await apiClient.post<ApiResponse<Session>>('/session', params);
  return responseData.data;
};

const useCreateSession = () => {
  return useMutation({
    mutationFn: createSession,
  });
};

export default useCreateSession;
